import React from 'react';
import { Company } from '@hum/types';
import { EMPTY_ARRAY } from '@hum/icm-app/src/state';
import { Empty } from '@hum/ui-library';
import { Table, TableCellConfig } from '@hum/legacy-ui';
import { useAppStore } from '@hum/icm-app/src/hooks/useAppStore';
import { getCompanyAnalysisWarnings, useApiQuery } from '@hum/api';

export const CompanyAnalysisWarnings = ({ company }: { company: Company }) => {
  const {
    state: { selectedCompanyAnalysisId },
  } = useAppStore();
  const {
    data: queryCompanyAnalysisWarnings = EMPTY_ARRAY,
    isLoading: isLoadingCompanyAnalysisWarnings,
  } = useApiQuery(getCompanyAnalysisWarnings, {
    params: {
      companyId: company.uuid,
      companyAnalysisId: selectedCompanyAnalysisId,
    },
    enabled: !!selectedCompanyAnalysisId,
  });

  const data = queryCompanyAnalysisWarnings;
  const loaded = !isLoadingCompanyAnalysisWarnings;

  if (!loaded) {
    return <Empty message="Loading" />;
  }

  if (!data.length) {
    return <Empty message="No warnings have been generated." />;
  }

  const cellConfig: Record<string, TableCellConfig> = {
    message: {
      label: 'Message',
    },
    detailedMessage: {
      label: 'Details',
    },
  };

  const itemKey = 'value';

  const tableData = data.map((warning) => {
    const { id, message, detailedMessage } = warning;
    return {
      value: id,
      message,
      detailedMessage,
    };
  });

  return (
    <Table
      style={{ '--scrollbar-height': 'calc(4 * 42px)' }}
      companyAnalyses
      cellConfig={cellConfig}
      data={tableData}
      itemKey={itemKey}
      dontSortByDefault
    />
  );
};
